module.exports = __webpack_public_path__ + "static/img/02.4834761.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/uvegtablak-falburkolatok/02.jpg
// module id = 631
// module chunks = 0